<div class="checklist-container">

  <!-- Header -->
  <div class="checklist-header">
    <!-- <button class="back-btn" (click)="goBack()">
      <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"/>
      </svg>
    </button> -->
    <h1 class="header-title">Step-by-Step Checklist</h1>
  </div>

  <!-- MAIN WRAPPER -->
  <div class="checklist-wrapper">

    <!-- LEFT: Main Content -->
    <div class="checklist-main">

      <!-- Summary Card -->
      <div class="summary-card">
        <div class="summary-icon">
          <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
            <rect width="28" height="28" rx="8" fill="#EEF2FF"/>
            <path d="M7 9h10M7 13h8M7 17h6" stroke="#6366F1" stroke-width="2" stroke-linecap="round"/>
            <path d="M18 15l2 2 3-3" stroke="#6366F1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <div class="summary-text">
          <h2 class="summary-title">

<!-- ✅ CASE 1: No tasks -->
<ng-container *ngIf="allTasks?.length === 0; else hasTasks">
  No task yet
</ng-container>

<!-- ✅ CASE 2 & 3 -->
<ng-template #hasTasks>

  <!-- Pending tasks -->
  <ng-container *ngIf="pendingTasksCount > 0; else allDone">
    {{ pendingTasksCount }} Tasks in Your Checklist
  </ng-container>

  <!-- All completed -->
  <ng-template #allDone>
    All tasks completed in your checklist
  </ng-template>

</ng-template>
   

</h2>
          <p class="summary-subtitle"> Follow these steps.</p>
        </div>
      </div>

      <!-- Search Bar -->
      <div class="search-bar">
        <svg class="search-icon" width="18" height="18" viewBox="0 0 18 18" fill="none">
          <circle cx="8" cy="8" r="5.5" stroke="#9CA3AF" stroke-width="1.5"/>
          <path d="M13 13l2.5 2.5" stroke="#9CA3AF" stroke-width="1.5" stroke-linecap="round"/>
        </svg>
        <input
          type="text"
          class="search-input"
          placeholder="Search tasks..."
          [(ngModel)]="searchQuery"
          (input)="onSearch()"
        />
      </div>

      <!-- Time Filter Chips -->
      <div class="filter-chips-scroll">
        <div class="filter-chips">
          <button
            *ngFor="let filter of timeFilters"
            class="filter-chip"
            [class.active]="selectedTimeFilter === filter.value"
            (click)="selectTimeFilter(filter.value)"
          >
            {{ filter.label }}
            <span class="chip-count">{{ filter.count }}</span>
          </button>
        </div>
      </div>

      <!-- Category Filter Chips -->
      <div class="category-chips-scroll">
        <div class="category-chips">
          <button
            *ngFor="let cat of categoryFilters"
            class="category-chip"
            [class.active]="selectedCategory === cat.value"
            (click)="selectCategory(cat.value)"
          >
            {{ cat.label }}
          </button>
        </div>
      </div>

      <!-- Count -->
      <p class="checklist-count">{{ totalFilteredTasks }} tasks</p>

      <!-- Task List -->
      <div class="task-list" *ngIf="!loading">
        <div *ngFor="let group of filteredGroups" class="task-group">

          <!-- Group Header -->
          <div class="group-header">
            <div class="group-header-left">
              <span class="group-dot" [ngClass]="group.urgency"></span>
              <div>
                <p class="group-title">{{ group.title }}</p>
                <p class="group-subtitle">{{ group.subtitle }}</p>
              </div>
            </div>
            <span class="group-task-count">{{ group.tasks.length }} tasks</span>
          </div>

          <!-- Category Label -->
          <p class="group-category" *ngIf="group.category">{{ group.category }}</p>

          <!-- Task Cards -->
          <div class="task-cards">
            <div
              class="task-card-row"
              *ngFor="let task of group.tasks"
            >
            <div
    *ngIf="
      canAccessChecklist &&
      !isChecked(task.id) &&
      !task.completed
    "
    class="task-checkbox"
    (click)="onCheckboxClick(task); $event.stopPropagation()"
  >
  </div>
            
              <!-- Checkbox OUTSIDE the card — hidden once task is completed -->
              <!-- <div
                *ngIf="!isChecked(task.id) && !task.completed"
                class="task-checkbox"
                (click)="onCheckboxClick(task); $event.stopPropagation()"
              ></div> -->

              

              <!-- Card -->
              <div
                class="task-card"
                [class.task-card--selected]="selectedTask?.id === task.id"
                [class.task-card--checked]="isChecked(task.id) || task.completed"
                (click)="openTask(task)"
              >
                <div class="task-card-content">
                  <div class="task-card-main">
                    <h3 class="task-title" [class.task-title--done]="task.completed">
                      {{ task.title }}
                    </h3>
                    <span class="task-badge" [ngClass]="task.badgeType">{{ task.badge }}</span>
                    <span class="task-arrow">&#8250;</span>
                  </div>
                  <p class="task-description" [class.task-description--done]="task.completed">
                    {{ task.description }}
                  </p>
                  <span class="task-timeframe" [ngClass]="task.urgency">{{ task.timeframe }}</span>
                </div>
              </div>

            </div>
          </div>

        </div>

        <!-- Empty State -->
        <div class="empty-state" *ngIf="filteredGroups.length === 0">
          <p class="empty-text">No tasks found.</p>
        </div>
        <!-- Pagination -->
<div class="contacts-pagination" *ngIf="totalPages > 1">

  <button
    class="pagination-btn"
    [disabled]="currentPage === 1"
    (click)="changePage(currentPage - 1)">
    Previous
  </button>

  <div class="pagination-pages">

    <button
      *ngFor="let page of pages"
      class="pagination-page"
      [class.active]="currentPage === page"
      (click)="changePage(page)">
      {{ page }}
    </button>

  </div>

  <button
    class="pagination-btn"
    [disabled]="currentPage === totalPages"
    (click)="changePage(currentPage + 1)">
    Next
  </button>

</div>
      </div>

      <!-- Loading State -->
      <div class="loading-state" *ngIf="loading">
        <div class="spinner"></div>
        <p>Loading tasks...</p>
      </div>

    </div><!-- /checklist-main -->

    <!-- RIGHT: Task Detail Panel -->
    @if (selectedTask) {
      <div class="task-detail-panel" [class.active]="selectedTask">

        <!-- Header -->
        <div class="detail-panel__header">
          <span class="detail-panel__label">TASK DETAILS</span>
          <button class="detail-panel__close" (click)="closeDialog()" aria-label="Close">
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
            </svg>
          </button>
        </div>

        <!-- Badges Row -->
        <div class="detail-panel__identity">
          <div class="detail-panel__badge-wrap">
            <span class="dialog-timeframe-badge" [ngClass]="selectedTask.urgency">
              <span class="timeframe-dot"></span>
              {{ selectedTask.timeframe }}
            </span>
            <span class="dialog-library-badge" [ngClass]="selectedTask.badgeType">
              {{ selectedTask.badge }}
            </span>
          </div>
          <h2 class="detail-panel__name">{{ selectedTask.title }}</h2>
          <p class="detail-panel__category">{{ getGroupCategory(selectedTask.urgency) }}</p>
        </div>

        <div class="task-meta-line">
          <span class="task-meta-item">{{ getUrgencyLabel(selectedTask.urgency) }}</span>
          <span class="task-meta-dot">·</span>
          <span class="task-meta-item">{{ selectedTask.timeframe }}</span>
        </div>

        <!-- Notes -->
        <div class="detail-section">
          <p class="detail-section__label">NOTES</p>
          <div class="detail-notes">
            <svg class="detail-notes__icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2
                   M9 5a2 2 0 002 2h2a2 2 0 002-2
                   M9 5a2 2 0 012-2h2a2 2 0 012 2"/>
            </svg>
            <p class="detail-notes__text">{{ selectedTask.description }}</p>
          </div>
        </div>

      </div>
    }

  </div><!-- /checklist-wrapper -->

</div>

<!-- ═══════════════════════════════════════
     TASK COMPLETION CONFIRMATION POPUP
═══════════════════════════════════════ -->
@if (confirmTask) {
  <div class="confirm-overlay" (click)="cancelConfirm()">
    <div class="confirm-popup" (click)="$event.stopPropagation()">

      <!-- Icon -->
      <div class="confirm-icon-wrap">
        <div class="confirm-icon-ring">
          <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
            <path d="M6 16l7 7L26 9" stroke="#6366f1" stroke-width="2.5"
              stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
      </div>

      <!-- Content -->
      <h3 class="confirm-title">Mark as Completed?</h3>
      <p class="confirm-task-name">{{ confirmTask.title }}</p>
      <p class="confirm-subtitle">
        Once marked complete, this task will be locked and cannot be unchecked.
      </p>

      <!-- Actions -->
      <div class="confirm-actions">
        <button class="confirm-btn confirm-btn--cancel" (click)="cancelConfirm()">
          Not Yet
        </button>
        <button class="confirm-btn confirm-btn--confirm" (click)="confirmComplete()">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M3 8l4 4 6-6" stroke="#fff" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          Yes, Complete
        </button>
      </div>

    </div>
  </div>
}